










































































































import Vue from 'vue';
import { CouponClient, Coupon } from '@/assets/src/clients/coupon_client';
import { StripeClient, StripePlan, StripeCoupon } from '@/assets/src/clients/stripe_client';
import ROUTE_NAMES from '@/assets/src/routes';
import { IS_PROD } from '@/assets/src/configs';

const stripeCouponUrl = IS_PROD ? 'https://dashboard.stripe.com/coupons' : 'https://dashboard.stripe.com/test/coupons';

export default Vue.extend({
  name: 'ListCoupon',

  methods: {
    expired(dateString: string | null): boolean {
      if (!dateString) {
        return false;
      }
      return new Date() > new Date(dateString);
    },

    async listCoupons() {
      this.coupons = await this.couponClient.listCoupons();
    },

    async listStripeCoupons() {
      this.stripeCoupons = await this.stripeClient.listStripeCoupons();
    },

    async listStripePlans() {
      this.stripePlans = await this.stripeClient.listStripePlans();
    },

    async deleteCoupon(coupon: Coupon) {
      await this.couponClient.deleteCoupon(coupon.id);
      this.listCoupons();
    },

    async addCoupon() {
      if (!this.stripeCouponId || this.validPlanIds.length === 0) {
        return;
      }

      await this.couponClient.addCoupon({
        coupon_code: this.couponCode,
        description: this.description,
        stripe_coupon_id: this.stripeCouponId,
        valid_plan_ids: this.validPlanIds,
      });
      await this.listCoupons();
    },
  },

  async created() {
    await this.listCoupons();
    await this.listStripeCoupons();
    await this.listStripePlans();
  },

  data() {
    return {
      coupons: [] as Coupon[],
      couponClient: new CouponClient(),

      stripeCoupons: [] as StripeCoupon[],
      stripePlans: [] as StripePlan[],
      stripeClient: new StripeClient(),

      couponCode: '',
      description: '',
      stripeCouponId: '',
      validPlanIds: [] as string[],

      stripeCouponUrl,
    };
  },

  routeNames: ROUTE_NAMES,
});
